export var DashboardSortType;
(function (DashboardSortType) {
    DashboardSortType[DashboardSortType["ITEM_NAME_ASC"] = 10] = "ITEM_NAME_ASC";
    DashboardSortType[DashboardSortType["ITEM_NAME_DESC"] = 11] = "ITEM_NAME_DESC";
    DashboardSortType[DashboardSortType["TOTAL_WAITING_ASC"] = 20] = "TOTAL_WAITING_ASC";
    DashboardSortType[DashboardSortType["TOTAL_WAITING_DESC"] = 21] = "TOTAL_WAITING_DESC";
    DashboardSortType[DashboardSortType["TOTAL_ACTIVE_ASC"] = 30] = "TOTAL_ACTIVE_ASC";
    DashboardSortType[DashboardSortType["TOTAL_ACTIVE_DESC"] = 31] = "TOTAL_ACTIVE_DESC";
    DashboardSortType[DashboardSortType["LONGEST_WAITING_ASC"] = 40] = "LONGEST_WAITING_ASC";
    DashboardSortType[DashboardSortType["LONGEST_WAITING_DESC"] = 41] = "LONGEST_WAITING_DESC";
})(DashboardSortType || (DashboardSortType = {}));
//# sourceMappingURL=domain.js.map